module.exports = __webpack_public_path__ + "static/img/btn_0.ddf13957.jpg";